import FormatosTickets from './FormatosTickets';
export default FormatosTickets;